export const SET_AFFILIATES = 'SET_AFFILIATES';
